import React, { useEffect, useState } from "react";
import { Card, Row, Col, Badge, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getUserDetail } from "../../services/UserServices/UserService";
import { getUrl } from "../../services/Admin/adminServices";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import Spinner from "../components/Common/Spinner";
// 1. Keep the API function outside so it can be shared cleanly
const getUrlImage = async (img) => {
  try {
    const res = await getUrl(img);
    // Ensure we return the actual URL string from your API response
    return res?.data?.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// 2. Helper Component for Profile Image
const AsyncProfileImage = ({ imgKey }) => {
  const fallbackImage =
    "https://img.freepik.com/premium-vector/vector-flat-illustration-grayscale-avatar-user-profile-person-icon-profile-picture-business-profile-woman-suitable-social-media-profiles-icons-screensavers-as-templatex9_719432-1339.jpg";
  const [imgSrc, setImgSrc] = useState(fallbackImage);

  useEffect(() => {
    const fetchImage = async () => {
      if (imgKey) {
        const url = await getUrlImage(imgKey);
        if (url) setImgSrc(url);
      }
    };
    fetchImage();
  }, [imgKey]);

  return (
    <img
      className="img-fluid rounded-md user-image shadow-sm"
      style={{
        maxHeight: "250px",
        objectFit: "cover",
        borderRadius: "10px",
        border: "4px solid white",
      }}
      src={imgSrc}
      alt="Profile"
    />
  );
};

// 3. Helper Component for Documents (Handles both rendering and the "View" button)
const AsyncDocumentItem = ({ doc, index }) => {
  const [docUrl, setDocUrl] = useState(null);

  useEffect(() => {
    const fetchDocUrl = async () => {
      if (doc.link) {
        const url = await getUrlImage(doc.link);
        if (url) setDocUrl(url);
      }
    };
    fetchDocUrl();
  }, [doc.link]);

  return (
    <Col lg={4} md={6} sm={12}>
      <div
        className="cohost-item p-3 rounded d-flex flex-column align-items-center shadow-sm h-100"
        style={{ border: "1px solid #eee", background: "#fafafa" }}
      >
        <div className="w-100 mb-3">
          {doc.type === "image" ? (
            <img
              src={docUrl || ""} // Renders blank until the URL loads
              alt={`Upload ${index}`}
              style={{
                width: "100%",
                height: "150px",
                objectFit: "cover",
                borderRadius: "8px",
                backgroundColor: "#e9ecef", // Acts as a placeholder background
              }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: "150px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#e9ecef",
                borderRadius: "8px",
                fontSize: "40px",
              }}
            >
              📄
            </div>
          )}
        </div>

        <div className="w-100 text-center mt-auto">
          <h5 className="fw-bold mb-1 text-capitalize text-dark">
            {doc.type} File
          </h5>
          <div
            className="fw-bold mb-3 text-truncate"
            style={{ color: "#FFB200", fontSize: "12px" }}
          >
            ID: {doc._id}
          </div>
          <Button
            className="w-100"
            style={{ backgroundColor: "#64CAE5", border: "none" }}
            onClick={() => docUrl && window.open(docUrl, "_blank")}
            disabled={!docUrl} // Prevents clicking before the link resolves
          >
            {docUrl ? "View" : "Loading..."}
          </Button>
        </div>
      </div>
    </Col>
  );
};

// Main Component
const VendorDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState({}); // Changed from [] to {} since data is an object
  const [loading,setLoading]=useState(false)
  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await getUserDetail(id);
      setData(res?.data?.data?.data || {});
    } catch (error) {
      console.error(error);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { businessDetails } = data;

  return (
    <div>
    {loading ?    <Spinner /> : data.length === 0 ? "data not found": <div>
       <Card
        className="shadow-lg profile-card mb-5 border-0"
        style={{ backgroundColor: "#64CAE5" }}
      >
        <Row className="g-0">
          {/* Left side - Uses the new Async Profile Image component */}
          <Col
            md={4}
            className="d-flex align-items-center justify-content-center p-4"
          >
            <AsyncProfileImage imgKey={data?.image} />
          </Col>

          {/* Right side - Details */}
          <Col md={8}>
            <Card.Body className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <Card.Title
                  className="fs-3 fw-bold mb-0"
                  style={{ color: "#3C4464", textTransform: "capitalize" }}
                >
                  {data?.name}
                </Card.Title>
                <Badge
                  bg={data?.adminApprove === "Approved" ? "success" : "warning"}
                  className="px-3 py-2 text-dark bg-white border"
                >
                  {data?.adminApprove}
                </Badge>
              </div>

              {/* Details */}
              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  Business Name:
                </strong>
                <span
                  style={{
                    color: "#3C4464",
                    fontWeight: "500",
                    textTransform: "capitalize",
                  }}
                >
                  {data?.businessDetails?.businessName || "N/A"}
                </span>
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  User Type:
                </strong>
                <span style={{ color: "#3C4464", fontWeight: "500" }}>
                  {data?.userType}
                </span>
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  Email:
                </strong>
                <span style={{ color: "#3C4464", fontWeight: "500" }}>
                  {data?.email}
                </span>
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  Phone Number:
                </strong>
                {data?.phoneNumber ? (
                  <span style={{ color: "#3C4464", fontWeight: "500" }}>
                    {data?.countryCode} {data?.phoneNumber}
                  </span>
                ) : (
                  "_"
                )}
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  Address:
                </strong>
                <span style={{ color: "#3C4464", fontWeight: "500" }}>
                  {data?.address}
                </span>
              </div>

              <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  Joined Date:
                </strong>
                <span style={{ color: "#3C4464", fontWeight: "500" }}>
                  {data?.createdAt &&
                    new Date(data?.createdAt).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                </span>
              </div>
               <div className="mb-2 d-flex">
                <strong
                  className="me-4 w-50 text-white"
                  style={{ fontWeight: "600" }}
                >
                  Rating:
                </strong>
                <span style={{ color: "#3C4464", fontWeight: "500" }}>
          {data?.rating} {"⭐".repeat(Math.round(data?.rating || 0))} 
                </span>
              </div>
            </Card.Body>
          </Col>
        </Row>
      </Card>

    
      <h2
        className="mb-4 user-detail-title font-fm"
        style={{ fontSize: "50px", color: "#3C4464" }}
      >
        Business Overview
      </h2>
      <Card
        className="shadow-lg event-card mb-5 rounded-3 border-0"
        style={{ backgroundColor: "#64CAE5" }}
      >
        <Card.Body>
          <div className="event-item mb-2 p-3 rounded">
            <h5 className="fw-bold mb-3 text-black">About</h5>
            <p style={{ color: "#3C4464", fontWeight: "500" }}>
              {businessDetails?.description}
            </p>
            <hr className="border-white" />
            <div className="d-flex justify-content-between mb-1 mt-3">
              <strong className="label-text me-5 text-black">
                Experience:
              </strong>
              <span style={{ color: "#3C4464", fontWeight: "600" }}>
                {businessDetails?.experience ? businessDetails?.experience:"0" } Years
              </span>
            </div>
          </div>
        </Card.Body>
      </Card>

     {(businessDetails?.facebookLink || businessDetails?.websiteLink || businessDetails?.instagramLink) && (
  <div>
    <h2
      className="mb-4 user-detail-title font-fm"
      style={{ fontSize: "50px", color: "#3C4464" }}
    >
      Social Links
    </h2>
    <Card
      className="shadow-lg cohost-card mb-5 rounded-3 border-0"
      style={{ backgroundColor: "#64CAE5" }}
    >
      <Card.Body>
        {businessDetails?.websiteLink && (
          <div
            className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center shadow-sm"
            style={{ border: "1px solid #eee", background: "#fafafa" }}
          >
            <div>
              <h5 className="fw-bold mb-2 text-dark">Website</h5>
              <p
                className="mb-0"
                style={{ color: "#64CAE5", fontWeight: "600" }}
              >
                🌐 {businessDetails?.websiteLink}
              </p>
            </div>
            <Button
              style={{ backgroundColor: "#64CAE5", border: "none" }}
              onClick={() => {
                const url = businessDetails.websiteLink.startsWith('http') 
                  ? businessDetails.websiteLink 
                  : `https://${businessDetails.websiteLink}`;
                window.open(url, "_blank");
              }}
            >
              Visit
            </Button>
          </div>
        )}

        {businessDetails?.instagramLink && (
          <div
            className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center shadow-sm"
            style={{ border: "1px solid #eee", background: "#fafafa" }}
          >
            <div>
              <h5 className="fw-bold mb-2 text-dark">Instagram</h5>
              <p
                className="mb-0"
                style={{ color: "#64CAE5", fontWeight: "600" }}
              >
                <FaInstagram className="me-2" size={20} />{" "}
                {businessDetails?.instagramLink}
              </p>
            </div>
            <Button
              style={{ backgroundColor: "#64CAE5", border: "none" }}
              onClick={() => {
                const url = businessDetails.instagramLink.startsWith('http') 
                  ? businessDetails.instagramLink 
                  : `https://${businessDetails.instagramLink}`;
                window.open(url, "_blank");
              }}
            >
              Visit
            </Button>
          </div>
        )}

        {businessDetails?.facebookLink && (
          <div
            className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center shadow-sm"
            style={{ border: "1px solid #eee", background: "#fafafa" }}
          >
            <div>
              <h5 className="fw-bold mb-2 text-dark">Facebook</h5>
              <p
                className="mb-0"
                style={{ color: "#64CAE5", fontWeight: "600" }}
              >
                <FaFacebook className="me-2" size={20} />{" "}
                {businessDetails?.facebookLink}
              </p>
            </div>
            <Button
              style={{ backgroundColor: "#64CAE5", border: "none" }}
              onClick={() => {
                const url = businessDetails.facebookLink.startsWith('http') 
                  ? businessDetails.facebookLink 
                  : `https://${businessDetails.facebookLink}`;
                window.open(url, "_blank");
              }}
            >
              Visit
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  </div>
)}
     

    {businessDetails?.documents.length > 0 ? <div>
         <h2
        className="mb-4 user-detail-title font-fm"
        style={{ fontSize: "50px", color: "#3C4464" }}
      >
        Documents & Media
      </h2>
      <Card
        className="shadow-lg cohost-card mb-5 rounded-3 border-0"
        style={{ backgroundColor: "#64CAE5" }}
      >
        <Card.Body
          style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}
        >
          <Row className="g-4">
            {businessDetails?.documents?.map((doc, index) => (
              // Uses the new Async Document Item component
              <AsyncDocumentItem key={doc._id} doc={doc} index={index} />
            ))}
          </Row>
        </Card.Body>
      </Card></div>  : ""
    
     }
   
    </div> }
     


    </div>
  );
};

export default VendorDetails;
